export const Schema = {
  body: "",
	document_type: "",
	document_id: "",
};